import React from 'react'

import * as imagesdata from '../imagesdata'
import { FaLongArrowAltLeft } from "react-icons/fa";
import "../css/Error.css"
const Error = () => {

  const handleClick = () => {
    window.location.href = "/"
  }

  return (
    <div class="error-body">
      <div class="error-container">
        <div class="error-header">
          <h1>404</h1>
          <h3>Sayfa Bulunamadı!</h3>
        </div>
        <img src={imagesdata.Error} alt="not found" />
        <div class="error-footer">
          <p>
            Üzgünüz, erişmeye çalıştığınız sayfa bulunamadı. Lütfen ana sayfaya dönünüz!
          </p>
          <button className='error-footer-button-1 error-footer-button-2' onClick={handleClick}>
            <span style={{ display: "flex", alignItems: "center" }}><FaLongArrowAltLeft style={{ margin: "0 5px 0 0" }} size={20}/>Ana Sayfaya Geri Dön
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Error